import jQuery from "jquery";
let $ = jQuery;
import db from "./components/firebaseInit";
import store from "./store";
import moment from "moment-timezone";
import { bus } from "@/main";

var monthNamesShort = [
	"Jan",
	"Feb",
	"Mar",
	"Apr",
	"May",
	"Jun",
	"Jul",
	"Aug",
	"Sep",
	"Oct",
	"Nov",
	"Dec",
];
var countryList = ["United States", "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Anguilla", "Antigua &amp; Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas"
	, "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia &amp; Herzegovina", "Botswana", "Brazil", "British Virgin Islands"
	, "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Chad", "Chile", "China", "Colombia", "Congo", "Cook Islands", "Costa Rica"
	, "Cote D Ivoire", "Croatia", "Cruise Ship", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea"
	, "Estonia", "Ethiopia", "Falkland Islands", "Faroe Islands", "Fiji", "Finland", "France", "French Polynesia", "French West Indies", "Gabon", "Gambia", "Georgia", "Germany", "Ghana"
	, "Gibraltar", "Greece", "Greenland", "Grenada", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea Bissau", "Guyana", "Haiti", "Honduras", "Hong Kong", "Hungary", "Iceland", "India"
	, "Indonesia", "Iran", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kuwait", "Kyrgyz Republic", "Laos", "Latvia"
	, "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macau", "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Mauritania"
	, "Mauritius", "Mexico", "Moldova", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Namibia", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia"
	, "New Zealand", "Nicaragua", "Niger", "Nigeria", "Norway", "Oman", "Pakistan", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal"
	, "Puerto Rico", "Qatar", "Reunion", "Romania", "Russia", "Rwanda", "Saint Pierre &amp; Miquelon", "Samoa", "San Marino", "Satellite", "Saudi Arabia", "Senegal", "Serbia", "Seychelles"
	, "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "South Africa", "South Korea", "Spain", "Sri Lanka", "St Kitts &amp; Nevis", "St Lucia", "St Vincent", "St. Lucia", "Sudan"
	, "Suriname", "Swaziland", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor L'Este", "Togo", "Tonga", "Trinidad &amp; Tobago", "Tunisia"
	, "Turkey", "Turkmenistan", "Turks &amp; Caicos", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States Minor Outlying Islands", "Uruguay"
	, "Uzbekistan", "Venezuela", "Vietnam", "Virgin Islands (US)", "Yemen", "Zambia", "Zimbabwe"];

var tzStrings = [
	{ label: "Midway Island, Samoa (GMT-11:00)", value: "Pacific/Midway" },
	{ label: "Hawaii (GMT-10:00)", value: "Pacific/Honolulu" },
	{ label: "Alaska (GMT-09:00)", value: "America/Anchorage" },
	{
		label: "Pacific Time (US & Canada) (GMT-08:00)",
		value: "America/Los_Angeles",
	},
	{
		label: "Tijuana, Baja California (GMT-08:00)",
		value: "America/Tijuana",
	},
	{ label: "Arizona (GMT-07:00)", value: "America/Phoenix" },
	{
		label: "Mountain Time (US & Canada) (GMT-07:00)",
		value: "America/Denver",
	},
	{ label: "Central America (GMT-06:00)", value: "America/Managua" },
	{
		label: "Central Time (US & Canada) (GMT-06:00)",
		value: "America/Chicago",
	},
	{
		label: "Guadalajara, Mexico City, Monterrey (GMT-06:00)",
		value: "America/Mexico_City",
	},
	{ label: "Saskatchewan (GMT-06:00)", value: "America/Regina" },
	{
		label: "Bogota, Lima, Quito, Rio Branco (GMT-05:00)",
		value: "America/Bogota",
	},
	{
		label: "Eastern Time (US & Canada) (GMT-05:00)",
		value: "America/New_York",
	},
	{
		label: "Atlantic Time (Canada) (GMT-04:00)",
		value: "Canada/Atlantic",
	},
	{ label: "Caracas, La Paz (GMT-04:00)", value: "America/Caracas" },
	{ label: "Santiago (GMT-04:00)", value: "America/Santiago" },
	{ label: "Newfoundland (GMT-03:30)", value: "America/St_Johns" },
	{ label: "Brasilia (GMT-03:00)", value: "America/Sao_Paulo" },
	{
		label: "Buenos Aires, Georgetown (GMT-03:00)",
		value: "America/Argentina/Buenos_Aires",
	},
	{ label: "Greenland (GMT-03:00)", value: "America/Godthab" },
	{ label: "Montevideo (GMT-03:00)", value: "America/Montevideo" },
	{ label: "Cape Verde Is. (GMT-01:00)", value: "Atlantic/Cape_Verde" },
	{ label: "Azores (GMT-01:00)", value: "Atlantic/Azores" },
	{
		label: "Casablanca, Monrovia, Reykjavik (GMT+00:00)",
		value: "Africa/Casablanca",
	},
	{
		label: "Coordinated Universal Time (GMT+00:00)",
		value: "UTC",
	},
	{
		label:
			"Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London (GMT+00:00)",
		value: "Etc/Greenwich",
	},
	{
		label: "Western Europe Time, London, Lisbon, Casablanca (GMT+00:00)",
		value: "Europe/London",
	},
	{
		label: "Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna (GMT+01:00)",
		value: "Europe/Amsterdam",
	},
	{
		label:
			"Belgrade, Bratislava, Budapest, Ljubljana, Prague (GMT+01:00)",
		value: "Europe/Belgrade",
	},
	{
		label: "Brussels, Copenhagen, Madrid, Paris (GMT+01:00)",
		value: "Europe/Brussels",
	},
	{
		label: "Sarajevo, Skopje, Warsaw, Zagreb (GMT+01:00)",
		value: "CET",
	},
	{ label: "Amman (GMT+02:00)", value: "Asia/Amman" },
	{
		label: "Athens, Bucharest, Istanbul (GMT+02:00)",
		value: "Europe/Athens",
	},
	{ label: "Beirut (GMT+02:00)", value: "Asia/Beirut" },
	{ label: "Cairo (GMT+02:00)", value: "Africa/Cairo" },
	{ label: "Harare, Pretoria (GMT+02:00)", value: "Africa/Harare" },
	{
		label: "Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius (GMT+02:00)",
		value: "Europe/Helsinki",
	},
	{ label: "Jerusalem (GMT+02:00)", value: "Asia/Jerusalem" },
	{ label: "Kuwait, Riyadh, Baghdad (GMT+03:00)", value: "Asia/Kuwait" },
	{ label: "Baghdad (GMT+03:00)", value: "Asia/Baghdad" },
	{
		label: "Moscow, St. Petersburg, Volgograd (GMT+03:00)",
		value: "Europe/Moscow",
	},
	{ label: "Nairobi (GMT+03:00)", value: "Africa/Nairobi" },
	{ label: "Tbilisi (GMT+03:00)", value: "Asia/Baku" },
	{ label: "Tehran (GMT+03:30)", value: "Asia/Tehran" },
	{ label: "Abu Dhabi, Muscat (GMT+04:00)", value: "Asia/Muscat" },
	{ label: "Baku (GMT+04:00)", value: "Asia/Baku" },
	{ label: "Yerevan (GMT+04:00)", value: "Asia/Baku" },
	{ label: "Kabul (GMT+04:30)", value: "Asia/Kabul" },
	{ label: "Yekaterinburg (GMT+05:00)", value: "Asia/Yekaterinburg" },
	{
		label: "Islamabad, Karachi, Tashkent (GMT+05:00)",
		value: "Asia/Tashkent",
	},
	{
		label: "Chennai, Kolkata, Mumbai, New Delhi (GMT+05:30)",
		value: "Asia/Calcutta",
	},
	{ label: "Almaty, Novosibirsk (GMT+06:00)", value: "Asia/Almaty" },
	{ label: "Astana, Dhaka (GMT+06:00)", value: "Asia/Dhaka" },
	{ label: "Bangkok, Hanoi, Jakarta (GMT+07:00)", value: "Asia/Bangkok" },
	{ label: "Krasnoyarsk (GMT+07:00)", value: "Asia/Krasnoyarsk" },
	{
		label: "Beijing, Chongqing, Hong Kong, Urumqi (GMT+08:00)",
		value: "Asia/Hong_Kong",
	},
	{ label: "Kuala Lumpur (GMT+08:00)", value: "Asia/Kuala_Lumpur" },
	{ label: "Singapore (GMT+08:00)", value: "Asia/Singapore" },
	{ label: "Irkutsk, Ulaan Bataar (GMT+08:00)", value: "Asia/Irkutsk" },
	{ label: "Perth (GMT+08:00)", value: "Australia/Perth" },
	{ label: "Taipei (GMT+08:00)", value: "Asia/Taipei" },
	{ label: "Osaka, Sapporo, Tokyo (GMT+09:00)", value: "Asia/Tokyo" },
	{ label: "Seoul (GMT+09:00)", value: "Asia/Seoul" },
	{ label: "Yakutsk (GMT+09:00)", value: "Asia/Yakutsk" },
	{ label: "Adelaide (GMT+09:30)", value: "Australia/Adelaide" },
	{ label: "Darwin (GMT+09:30)", value: "Australia/Darwin" },
	{ label: "Brisbane (GMT+10:00)", value: "Australia/Brisbane" },
	{
		label: "Canberra, Melbourne, Sydney (GMT+10:00)",
		value: "Australia/Sydney",
	},
	{ label: "Hobart (GMT+10:00)", value: "Australia/Hobart" },
	{ label: "Guam, Port Moresby (GMT+10:00)", value: "Pacific/Port_Moresby" },
	{ label: "Vladivostok (GMT+10:00)", value: "Asia/Vladivostok" },
	{
		label: "Magadan, Solomon Is., New Caledonia (GMT+11:00)",
		value: "Asia/Magadan",
	},
	{
		label: "Auckland, Wellington (GMT+12:00)",
		value: "Pacific/Auckland",
	},
	{
		label: "Fiji, Kamchatka, Marshall Is. (GMT+12:00)",
		value: "Pacific/Fiji",
	}
];
//let vm;
export default {
	getCountryList() {
		return countryList;
	},
	getTimeZones() {
		return tzStrings;
	},
	enablePlayerMenuToggle(enablePlayerMenuToggle) {
		if (enablePlayerMenuToggle) {
			$(".menu-player-info-switch").addClass("in-player");
			$(".menu-player-info-switch").removeClass("d-none");
			$(".menu-back").addClass("d-none");
			this.toggleMenuPlayerInfo(true);
		}
		else {
			$(".menu-player-info-switch").removeClass("in-player");
			$(".menu-player-info-switch").addClass("d-none");
			$(".menu-back").removeClass("d-none");
			this.toggleMenuPlayerInfo(false);
		}
	},
	toggleMenuPlayerInfo(showSessionInfo) {
		if ($(".menu-player-info-switch").hasClass("in-player") &&
			$(".menu-player-info-switch .player-info").hasClass("player-info-close")) {
			showSessionInfo = true;
		}
		if (showSessionInfo) {
			//alert("show")
			$(".menu-player-info-switch .player-info")
				.removeClass("player-info-close")
				.addClass("player-info-menu");
			$("#topMenuWrap")
				.addClass("d-none")
				.removeClass("d-md-flex")
				.removeClass("d-lg-flex");
			$("#menuSessionInfo").removeClass("d-none");
		} else {
			//alert("hide")
			$(".menu-player-info-switch .player-info").removeClass(
				"player-info-menu"
			);
			$(".menu-player-info-switch .player-info").addClass(
				"player-info-close"
			);
			$("#topMenuWrap")
				.removeClass("d-none")
				.addClass("d-md-flex")
				.addClass("d-lg-flex");
			$("#menuSessionInfo").addClass("d-none");
		}
	},
	getInitials: function (str) {
		var result = "";
		if (str) {
			str = str.trim();
			if (str) {
				var matches = str.match(/\b(\w)/g);
				if (matches) {
					result = matches.join("");
					if (result.length > 2) {
						result = result.substring(0, 2);
					}
				} else {
					result = str.substring(0, 2);
				}
			}
		}
		return result.toUpperCase();
	},
	checkAppDownloadScreenByDevice(device) {
		var docRefGeneralSettings = db.collection("OA_UAT").doc("GeneralSettings");
		if (device == "mobile") {
			docRefGeneralSettings.get().then(function (doc) {
				if (doc.exists) {
					var data = doc.data();
					if (data != null && data.PlayerSettings.AgoraPlayerBrowserSupportInMobile == false) {
						store.commit("setPlayerForMobile", false);
					} else {
						store.commit("setPlayerForMobile", true);
					}
				}
			});
		} else {
			docRefGeneralSettings.get().then(function (doc) {
				if (doc.exists) {
					var data = doc.data();
					if (data != null && data.PlayerSettings.AgoraPlayerBrowserSupportInIPad == false) {
						store.commit("setPlayerForIPad", false);
					} else {
						store.commit("setPlayerForIPad", true);
					}
				}
			});
		}
	},
	getFormattedTime: function (seconds) {
		var dt = new Date(seconds * 1000);
		var hours = dt.getHours();
		var minutes = dt.getMinutes();
		var amPM = hours < 12 || hours == 0 ? "AM" : "PM";
		hours = hours > 12 ? hours - 12 : hours;
		hours = hours == 0 ? 12 : hours;
		let minutesStr = minutes < 10 ? "0" + minutes.toString() : minutes.toString();
		var formattedtime =
			hours.toString() + ":" + minutesStr + " " + amPM;
		return formattedtime;
	},
	getFormattedDateTime: function (seconds) {
		var dt = new Date(seconds * 1000);
		var day = dt.getDate();
		var month = dt.getMonth();
		//alert(day);
		//alert(month);
		var hours = dt.getHours();
		var minutes = dt.getMinutes();
		var amPM = hours < 12 || hours == 0 ? "AM" : "PM";
		hours = hours > 12 ? hours - 12 : hours;
		hours = hours == 0 ? 12 : hours;
		let minutesStr = minutes < 10 ? "0" + minutes.toString() : minutes.toString();
		var formattedtime =
			hours.toString() + ":" + minutesStr + " " + amPM;
		formattedtime = monthNamesShort[month] + " " + day + ", " + formattedtime;
		return formattedtime;
	},
	getTimeZoneName(timeZone) {
		var result = "";
		if (!timeZone) {
			timeZone = moment.tz.guess();
		}
		tzStrings.map((item) => {
			if (item.value == timeZone) {
				result = item.label;
			}
		});
		if (!result) {
			result = timeZone;
		}
		return result;
	},
	getHeaderHeight(isModal) {
		//console.log(isModal);
		var height = 0;
		var obj = document.getElementById("divHeader");
		if (obj) {
			height = obj.offsetHeight;
		}
		if (isModal && height && window.innerHeight != screen.height) {
			height = height - 47;
		}
		return `height:calc(100vh - ${height}px)`;
		//return `height:calc(100%)`;
	},
	getPageFullHeight(isModal) {
		//console.log(isModal);
		var height = 0;
		var obj = document.getElementById("divHeader");
		if (obj) {
			height = obj.offsetHeight;
		}
		if (isModal && height && window.innerHeight != screen.height) {
			//height = height - 47;
		}
		return `height:calc(100vh - ${height}px)`;
		//return `height:calc(100%)`;
	},
	getHeaderHeightPercent(isModal) {
		var height = 0;
		var obj = document.getElementById("divHeader");
		if (obj) {
			height = obj.offsetHeight;
		}
		if (isModal && height && window.innerHeight != screen.height) {
			height = height - 47;
		}
		return `height:calc(100% - ${height}px)`;
	},
	toggleTopMenu(val) {
		var obj = document.getElementById("topmenu");
		if (obj) {
			if (val == true) {
				$("#topmenu").show();
			}
			else {
				$("#topmenu").hide();
			}
		}
	},
	toggleLeftMenu(val) {
		var obj = document.getElementById("leftmenu");
		if (obj) {
			if (val) {
				$("#leftmenu").show();
			}
			else {
				$("#leftmenu").hide();
			}
		}
	},
	openRegistrationDialog() {
		bus.$emit("toggleLoader", true);
		bus.$emit("openRegistrationDialog", store.getters.getEvent);
		setTimeout(() => {
			bus.$emit("toggleLoader", false);
		}, 2000);
	},
	closeRegistrationDialog() {
		bus.$emit("closeRegistrationDialog");
	}
};